<!--
 * @Author: your name
 * @Date: 2020-12-11 20:45:50
 * @LastEditTime: 2021-03-05 15:53:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-input-info/index.vue
-->
<style scoped lang="sass">
.app_container
  display: flex
  flex-direction: column
  align-items: center
  padding-top: 38px

.img_container
  height: 95px

.img
  height: 100%
  object-fit: cover
</style>

<template lang="pug">
.app_container
  .img_container
    img.img(:src="imgSrc")
  router-view(
    v-model="loading"
    :show-tab-dialog.sync="showTabDialog"
    :show-tab-dialog-type.sync="showTabDialogType"
    :tab-payment="tabPayment"
    :tab-detail="tabDetail"
    :tab-info="tabInfo"
    :old-payment-detail="oldPaymentDetail"
    :disabled-payment-input="disabledPaymentInput"
    :has-token="hasToken"
    @enablePaymentInput="enablePaymentInput"
  )
  py-loading(:showLoading="loading")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getVenue } from '@/api/product'
import { loading } from 'utils/decorators'
import { getTabDetail } from 'api/tab'
import {
  _formatCardNum,
  _getFormatDate,
  _getFormatTime,
} from 'utils/format'

@Component({
  watch: {
    async $route(to, from) {
      if (to.name === 'tab-info') {
        if (from.name === 'tab-payment') {
          // do nothing
        } else {
          await this.getData()
        }
      }
    },
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: String
    }
  },

  computed: {
    tabInfo() {
      return {
        ...this.tabDetail,
        paymentDetail: this.tabPayment
      }
    },

    // "Is there a card on file?" — since backend migration wave 2 (2026-09-10) the tab response no
    // longer carries the reusable card token (or the CVC), only the masked card number the gateway
    // stored. The masked number is therefore the signal; `token` is kept in the check for older
    // backends that still send it.
    hasToken() {
      return !!(this.oldPaymentDetail.token || this.oldPaymentDetail.cardNumber)
    }
  },

  async created() {
    // close user-part loading
    this.$store.commit('closeLoading')
    await this.getData()
  }
})

class TabInputInfo extends Vue {
  disabledPaymentInput = false
  tabDetail = {
    id: null,
    name: null,
    email: null,
    phone: null,
    openDateTime: {
      date: null,
      time: null
    },
    tabAmount: null,
    minAmount: null,
  }

  tabPayment = {
    name: null,
    cardNumber: null,
    cvc: null,
    expireMonth: null,
    expireYear: null,
    cardExpiry: '',
    type: 'creditCard',
  }

  oldPaymentDetail = {
    name: null,
    cardNumber: null,
    cvc: null,
    expireMonth: null,
    expireYear: null,
    cardExpiry: '',
    type: 'creditCard',
  }

  showTabDialogType = ''
  showTabDialog = false
  imgSrc = ''
  loading = false

  enablePaymentInput() {
    this.disabledPaymentInput = false
  }

  @loading('loading')
  async getData() {
    const [venueInfo, routerRes] = await Promise.all([this.getVenueInfo(), this._checkRouterName()])
  }

  async _checkRouterName() {
    if (this.$route.name !== 'tab-code') {
      await this._getTabDetail()
    }
  }

  async getVenueInfo() {
    const res = await getVenue({
      id: this.$route.params.venueId
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.imgSrc = res.secLogo
  }

  async _getTabDetail() {
    const res = await getTabDetail({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: localStorage.getItem('tabPassCode')
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    if (res.status !== 0) {
      this.jumpToMenu()
      return
    }
    const { paymentDetail, ...tabDetail } = res
    this.tabDetail = { ...tabDetail }
    this.tabDetail.openDateTime.date = _getFormatDate(this.tabDetail.openDateTime.date)
    this.tabDetail.openDateTime.time = _getFormatTime(this.tabDetail.openDateTime.time)
    this.tabPayment = {
      ...paymentDetail,
      // the backend no longer returns the CVC (it is not stored any more); send '' back when the
      // card on file is kept — the backend treats a masked number without a token as "same card"
      cvc: paymentDetail.cvc || '',
      cardNumber: _formatCardNum(paymentDetail.cardNumber),
      cardExpiry: paymentDetail.expireMonth + ' / ' + paymentDetail.expireYear,
      type: 'creditCard',
    }
    this.oldPaymentDetail = JSON.parse(JSON.stringify({
      ...paymentDetail,
      cardNumber: _formatCardNum(paymentDetail.cardNumber),
      cardExpiry: paymentDetail.expireMonth + ' / ' + paymentDetail.expireYear,
    }))
    // card on file (masked number present, token no longer sent) → fields locked until "Change Details"
    this.disabledPaymentInput = !!(this.oldPaymentDetail.token || this.oldPaymentDetail.cardNumber)
  }

  jumpToMenu() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabId}/menu`,
    })
  }
}

export default TabInputInfo
</script>
